import React, { useEffect, useState } from "react";
import CampaignIcon from "@mui/icons-material/Campaign";
import "./SuperSpeakerNotification.css";
import micIcon from "../../../../assets/mic_icon.svg";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toggleGlobalLivekitMic } from "../../../MediaPlayback/store/GlobalLivekitSlice/GlobalLivekitSlice";
import { setIsSuperSpeakerActive, stopannouncement } from "../../store/Announcement/AnnouncementSlice";


export const SuperSpeakerNotification = () => {

  const { t } = useTranslation();
  const dispatch = useDispatch();


  const [countdown, setCountdown] = useState(5);
  const handleStartSuperSpeaker = () => {
    dispatch(toggleGlobalLivekitMic(true));
  }

  const handleStopSuperSpeaker = () => {
    dispatch(toggleGlobalLivekitMic(false));
    dispatch(setIsSuperSpeakerActive(false));
        dispatch(stopannouncement({
        }));
  }

  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prevTime) => prevTime - 1);
      }
        , 1000);
    }
    return () => clearInterval(timer);
  }, [countdown]);


  useEffect(() => {
    if (countdown === 0) {
      handleStartSuperSpeaker();
    }
  }, [countdown]);

  useEffect(() => {
    return () => {
      // Cleanup on unmount
      dispatch(toggleGlobalLivekitMic(false));
    };
  }, []);


  return (
    <div className="announcement-notification-message">
      <div className="announcement-notification-inner">
        <div className="content">
          <div className="announcement-notification-header">
            <div className="left-section">
              <img
                src={micIcon}
                alt={t("announcement_in_progress_title")}
                className="announcement-notification-image"
              />
              <div className="title">{t("announcement_in_progress_title")}</div>
            </div>
            <CampaignIcon sx={{ color: "black" }} className="campaign-icon" />
          </div>{countdown > 0 && (<>
            <div className="message">{t("announcement_mic_activating_message")}</div>
          </>)}
          {countdown <= 0 && (<>
            <div className="message">{t("announcement_mic_in_progress_message")}</div>
            <div className="message">{t("announcement_activated_message")}</div>
          </>)}
        </div>

        {countdown > 0 && (
          <div className="announce-time">{t("time_remaining")} : {countdown}s</div>
        )}
        {countdown <= 0 && (
          <button
            className="stop-button"
            onClick={handleStopSuperSpeaker}
          >
            {t("stop_announcement")}
          </button>
        )}

      </div>
    </div>
  );
};